<template>
    <section>
        <div class="mx-auto px-4">
            <div class="flex flex-wrap -mx-2">
                <div class="w-full px-2 md:w-1/2">
                <div class="flex flex-wrap items-center gap-2">
                    <input class="form-control" @keyup.enter="check" v-model="serialNumber">
                  <button class="btn btn-primary" @click="check"><i v-if="loading" class="fa fa-spinner fa-spin"></i> Kontrola</button>
                </div>
                <br>
                <p>{{message}}</p>
                </div>
                <div class="w-full px-2 md:w-1/2">
                    <qrcode-stream @detect="onDetect"></qrcode-stream>
                </div>
            </div>
        </div>
    </section>

</template>

<script>
    import storage, {CHECK_API} from '../_store'
    import { QrcodeStream } from 'vue-qrcode-reader'

    const TRANSMITTER_RE = /^[0-9a-fA-F]{1,2}-?[0-9a-fA-F]{6,6}$/
    const HOMEBASE_RE = /^[0-9a-fA-F]{4}-?[0-9a-fA-F]{4}-?[0-9a-fA-F]{4}-?[0-9a-fA-F]{4}$/

    export default {
        name: 'CheckDevice',
        components: {
            QrcodeStream
        },
        data () {
            return {
                serialNumber: '',
                message: '',
                loading: false
            }
        },
        methods: {
            check () {
                if (this.isValid(this.serialNumber)) {
                    this.loading = true
                    storage.dispatch(CHECK_API, this.serialNumber)
                        .then(resp => {
                            this.loading = false
                            this.message = this.statusMessage(resp.data.status)
                        }).catch(error => {
                            this.loading = false
                            const response = error && error.response
                            const retryAfter = response && response.headers
                                ? response.headers['retry-after']
                                : null
                            this.$b_notify({
                                type: 'danger',
                                content: response && response.status === 429
                                    ? `Příliš mnoho kontrol. Zkuste to znovu za ${retryAfter || 'několik'} sekund.`
                                    : 'Stav zařízení nelze ověřit.'
                            })
                        })
                } else {
                    this.message = 'Stav zařízení nelze ověřit.'
                }
            },
            onDetect (detectedCodes) {
                const raw = Array.isArray(detectedCodes) && detectedCodes[0]
                    ? (detectedCodes[0].rawValue || detectedCodes[0].raw || '')
                    : ''
                const decodedString = String(raw).replace('https://energomonitor.cz/sn/', '')
                this.serialNumber = decodedString
                if (this.isValid(this.serialNumber)) {
                    this.check()
                }
            },
            isValid (string) {
                return String(string).match(TRANSMITTER_RE) || String(string).match(HOMEBASE_RE)
            },
            statusMessage (status) {
                if (status === 'recent') {
                    return 'Zařízení komunikovalo během posledních 15 minut.'
                }
                if (status === 'today') {
                    return 'Zařízení komunikovalo během posledních 24 hodin.'
                }
                return 'Zařízení delší dobu nekomunikovalo nebo jeho stav nelze ověřit.'
            }
        }
    }
</script>

<style scoped>

</style>
